import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchLocations = institutionId => {
    return RESTClient.getAuthenticatedObservable('v2/accident-reports/locations', {institutionId}).map(results =>
        List(results.locations),
    );
};
